import { memo as Memo, useMemo, useRef, useCallback } from 'react'
import gsap from 'gsap'

//* HOC's
import { withUIContext } from 'context'

//* Components
import Animate from 'components/common/Animate'
import Container from 'components/common/Container'
import Text from 'components/common/Text'
import Image from 'components/common/Image'

//* Styles
import AbstractMouseEffectStyle from './style'

const AbstractMouseEffect = Memo(({ title, description, images, first, sectionBg = 'bgBlackPearl', winWidth }) => {
	//! Refs
	const titleRef = useRef()
	const descriptionRef = useRef()
	const imageRefs = useRef([])

	//! Images
	const imageItems = useMemo(() => {
		return (
			images &&
			images.length === 5 &&
			images.map((i, k) => {
				return (
					(winWidth > 767 || (winWidth <= 767 && k !== 4)) && (
						<div
							key={k}
							ref={(ref) => (imageRefs.current[k] = ref)}
							className={`ame-image ame-image-${k + 1} ame-image-${k === 2 || k === 4 ? 'portrait' : 'landscape'}`}
						>
							<Image src={i.url} alt={i.alt} objectFit='cover' />
						</div>
					)
				)
			})
		)
	}, [images, winWidth])

	//! Handle Mouse Move
	const handleMouseMove = useCallback(
		(e) => {
			const x = e.clientX
			const y = e.clientY
			const windowWidthPart = window.innerWidth / 2
			const windowHeightPart = window.innerHeight / 2
			const xPercent = (windowWidthPart - x) / windowWidthPart
			const yPercent = (windowHeightPart - y) / windowHeightPart

			for (let i = 0; i < imageRefs.current.length; i++) {
				gsap.to(imageRefs.current[i], {
					x: `${(i + 7) * 6 * xPercent}%`,
					y: `${(i + 5) * 10 * yPercent}%`,
					duration: 1,
				})
			}
		},
		[imageRefs.current, winWidth]
	)

	return (
		images &&
		images.length === 5 && (
			<Animate params={{ bottomToTop: [titleRef, descriptionRef], opacity: [imageRefs] }}>
				<Container section first={first} full>
					<AbstractMouseEffectStyle onMouseMove={handleMouseMove} className={`${sectionBg}`}>
						<div className='ame-info-container'>
							{title && (
								<div className='hidden-container'>
									<Text ref={titleRef} text={title} tag={first ? 'h1' : 'h2'} className={`font-soundscape h2 ame-title`} />
								</div>
							)}
							{description && (
								<div className='hidden-container'>
									<Text
										ref={descriptionRef}
										text={description}
										tag={first && !title ? 'h1' : 'h3'}
										className={`font-ping-medium h6 ame-description`}
									/>
								</div>
							)}

							{imageItems}
						</div>
					</AbstractMouseEffectStyle>
				</Container>
			</Animate>
		)
	)
})

export default withUIContext(AbstractMouseEffect, ['winWidth'])
